export default "__VITE_ASSET__DAjGEzDa__";